import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormUtils } from '../../../../../shared/helpers/formUtils';
import { EYesNo } from '../../../../../shared/models/types.enum';

@Component({
  selector: 'witness-summary',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './witness-summary.component.html',
  styleUrl: './witness-summary.component.css'
})
export class WitnessSummaryComponent implements OnInit, OnChanges {

  @Input() witnessInterviewData: any = {};
  @Output() onSaveSection5 = new EventEmitter<any>();

  yesNo = EYesNo;
  witnessSummaryForm: FormGroup = new FormGroup([]);
  questionList = [
    {
      question: "Is there anyone else who might know something about this student in relation to this situation? (List all names)",
      formControlName: "student_relation",
    }
  ]

  radioQuestions = [
    {
      id: 'other',
      questionText: 'Is there other information regarding this student you have not yet shared that you believe would be important for the threat assessment team to consider? *',
      formControlName: 'other',
      infoFormControlName: 'other_information'
    }
  ];

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private formUtils: FormUtils
  ) {}

  ngOnInit() {
    this.initializeForm();
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['witnessInterviewData'] && this.witnessInterviewData) {
      this.initializeForm();
    }
  }

  private initializeForm() {
    const group: any = {};
    
    this.radioQuestions.forEach(question => {
      const defaultValue = this.witnessInterviewData && this.witnessInterviewData[question.formControlName] !== undefined
                           ? this.witnessInterviewData[question.formControlName]
                           : this.yesNo.No;  

      group[question.formControlName] = new FormControl(
          String(defaultValue), 
          Validators.required
      );
      group[question.infoFormControlName] = new FormControl({ value: this.witnessInterviewData?.[question.infoFormControlName] || '', disabled: this.witnessInterviewData?.[question.infoFormControlName] ? false : true });
    });
    this.questionList.forEach(question => {
      group[question.formControlName] = new FormControl(this.witnessInterviewData?.[question.formControlName] || '', Validators.required);
    });

    this.witnessSummaryForm = new FormGroup(group);
    this.setupFormChangeHandlers();
  }

  setupFormChangeHandlers() {
    this.radioQuestions.forEach(question => {
      const control = this.witnessSummaryForm.get(question.formControlName);
      if (control) {
        control.valueChanges.subscribe(value => {
          const infoControl = this.witnessSummaryForm.get(question.infoFormControlName);
          if (infoControl) {
            this.formUtils.handleConditionChange(infoControl, value === EYesNo.Yes);
          }
        });
      }
    });
  }

  saveWitnessSummary(): void {
    if (this.witnessSummaryForm.valid) {
      this.onSaveSection5.emit(this.witnessSummaryForm.value);
    }
  }


}
